import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor
} from '@angular/common/http';
import { Observable} from 'rxjs';
import { environment } from 'src/environments/environment';
import { AuthService, AuthType } from '../services/auth.service';

@Injectable()
export class IdenediAPIVersioningInterceptor implements HttpInterceptor {

  constructor(private authService : AuthService) {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    const authType = this.authService.getAuthType(request);
     
    if(authType == AuthType.Idenedi)
    { 
      if(!request.headers.has("Idenedi-Api-Version")) {
        request = request.clone({
            setHeaders: { "Idenedi-Api-Version": "5" }
        });
      }
    }    
    return next.handle(request);
  }
}
